<template>
    <b-modal id="wrapperSearchModal" :title="title" size="md">
        <div class="table_list">
            <ul class="search_filter">
                <li>
                    <p>{{ searchName }}</p>
                    <input type="text" :placeholder="`${searchName}을(를) 입력하세요`" class="form_control">
                    <button class="btn btn_md btn_outline" @click="fn_search">조회</button>
                </li>
              <li v-show="filter">
                <div class="form_radio">
                  <input type="radio" id="radio1" name="radio" value="" checked v-model="outStdrStock">
                  <label for="radio1">전체</label>
                </div>
                <div class="form_radio">
                  <input type="radio" id="radio2" name="radio" value="O" checked v-model="outStdrStock">
                  <label for="radio2">기준재고량 미달</label>
                </div>
              </li>
            </ul>
            <div class="modal_table">
                <table class="list">
                    <colgroup>
                        <col width="50">
                        <col width="50">
                    </colgroup>
                    <thead>
                        <tr>
                            <th></th>
                            <th>No</th>
                            <th>포장지명</th>
                            <th>재고량</th>
                        </tr>
                    </thead>
                    <tbody>
                    <tr v-if="wrapperWrhsList.length == 0">
                        <td colspan="6"><span>데이터가 없습니다.</span></td>
                    </tr>
                    <tr v-for="(item, index) in wrapperWrhsList" :key="index">
                        <td>
                            <div class="form_checkbox" style="min-width:auto">
                                <input type="checkbox" :id="'checkbox'+index" name="checkbox" v-model="checkBox" :value="index" @change="fn_check">
                                <label :for="'checkbox'+index"></label>
                            </div>
                        </td>
                        <td><span>{{ index + 1 }}</span></td>
                        <td><span>{{ item.wrapper_nm }}</span></td>
                        <td><span>{{ item.stock }}</span></td>
                    </tr>
                    </tbody>
                </table>
            </div>
        </div>
        <template #modal-footer="{ ok }">
            <b-button class="btn btn_md btn_gray" v-show="oneBtn" @click="fn_apply">{{ btnLeft }}</b-button>
            <b-button class="btn btn_md btn_deepblue" @click="fn_init(),ok()">{{ btnRight }}</b-button>
        </template>
    </b-modal>

</template>

<script>
    import axios from 'axios'

    export default {
        name: 'wrapperSearchModal',
        props: {
            title: String,
            btnLeft: String,
            btnRight: String,
            tableHead: Array,
            data: Array,
            searchName: String,
            searchData: String,
            oneBtn: Boolean,
            filter: Boolean
        },
        data() {
            return {
                checkBox : [],
                wrapperWrhsList : [],
                wrapperNm : this.searchData,
                outStdrStock : ''
            }
        },
        methods : {
            fn_search(){

                let param = new Object();
                param.wrapperNm = this.wrapperNm;
                param.outStdrStock = this.outStdrStock;

                console.log("@@@@ param : %o",param);

                axios
                    .post("/api/admin/wrapper/getModalWrapper", param)
                    .then((res) => {
                        console.log("@@@@ dtl res : %o",res);
                        this.wrapperWrhsList = res.data.wrapperInfo;
                    })
                    .catch((err) => console.log(err));
                
            },
            fn_apply(){
                               
                if(this.checkBox.length == 0){
                    alert("체크된 포장재가 없습니다.");
                }else if(this.checkBox.length > 1){
                    alert("한개 이상 선택할수 없습니다.");
                }else{                    
                    let wrapperCode = this.wrapperWrhsList[this.checkBox[0]].wrapper_cd;
                    let wrapperName = this.wrapperWrhsList[this.checkBox[0]].wrapper_nm;                    

                    console.log("@@@@ wrapperCode : "+wrapperCode);
                    console.log("@@@@ wrapperName : "+wrapperName);

                    this.$emit('callback', wrapperCode, wrapperName);

                    this.fn_init();
                    this.$bvModal.hide('wrapperSearchModal');
                }                                        
            },
            fn_init(){
                this.wrapperWrhsList = [];
                this.checkBox = [];
                this.wrapperNm = '';
                this.outStdrStock = '';
            },
            fn_check(){                
                 if(this.checkBox.length > 1){
                     this.checkBox.splice(0,1);
                 }
            }
        }
    }
</script>

